<template>
    <div class="contact-details">
        <div class="user-info-profile" v-if="showProfileTop" @click="viewContactProfile">
            <div class="profile-header">
                <ContactAvatar
                    :contact="contact"
                    :key="contact._id"
                    :badge="true"
                    :badge-type="IsVisitorOnline() ? 'visitor-online' : 'visitor-offline'"
                />
                <div class="contact-profile-info">
                    <div class="contact-profile-fullname">
                        <div
                            class="material-icons vip"
                            v-if="contact.vipCustomer"
                            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }"
                            :content="'★ VIP Customer'"
                        >
                            star
                        </div>
                        {{ getVal("fullname") }}
                    </div>
                    <div class="platform-info">
                        <div class="platform-name">
                            <div class="platform-icon-wrapper">
                                <WhatsappIcon
                                    v-if="contact.platform === 'whatsapp'"
                                    color="#25D366"
                                    class="option-icon"
                                />
                                <TelegramIcon v-if="contact.platform === 'telegram'" class="option-icon" />
                                <MessengerIcon v-if="contact.platform === 'messenger'" class="option-icon" />
                                <webIcon v-if="contact.platform === 'web'" class="option-icon" color="black;" />
                                <mailIcon v-if="contact.platform === 'email'" class="option-icon" />
                                <MetaIcon v-if="contact.platform === 'meta-leads'" class="option-icon" />
                                <InstagramIcon
                                    v-if="contact.platform === 'instagram'"
                                    class="option-icon"
                                    special-background-mode
                                />
                                {{ getPlatformName() }}
                            </div>
                        </div>
                        <div
                            v-if="contact.platform === 'whatsapp'"
                            class="whatsapp-number"
                            @click.stop="showWhatsappChatStarterModal = true"
                        >
                            <a href="javascript:void(0)">{{ maskContactInfo("phone", contact.whatsappNumber, 5) }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal2
            v-if="showWhatsappChatStarterModal"
            @cancel="showWhatsappChatStarterModal = false"
            :title="$t('message.whatsappChatStart')"
            :showFooter="false"
        >
            <WhatsappChatStarter
                :default-phone-number="contact.whatsappNumber"
                channel-override
                phone-number-override
                @close="showWhatsappChatStarterModal = false"
                :default-email="contact.email"
                :default-name="contact.name || contact.fullname"
            />
        </Modal2>
        <div class="user-info-details-wrapper">
            <div class="user-info-details-title">{{ $t("visitor.visitorDetail") }}</div>
            <div class="user-info-details-content">
                <ContactDetailItem
                    :contact="contact"
                    :label="$t('message.ownership')"
                    :value="getVal('owner')"
                    :showEdit="true"
                    :showDelete="false"
                    :showCopy="true"
                    field="owner"
                    :input-type="'select'"
                    @edit="updateContactDetailKey('owner', $event)"
                    @add="addContactDetailKey('owner', $event)"
                >
                    <template #icon>
                        <div class="material-icons">person</div>
                    </template>
                </ContactDetailItem>
                <ContactDetailItem
                    :contact="contact"
                    :label="'VIP Customer'"
                    :value="getVal('vipCustomer')"
                    :showEdit="true"
                    :showDelete="false"
                    :showCopy="true"
                    field="vipCustomer"
                    :input-type="'switch'"
                    @edit="updateContactDetailKey('vipCustomer', $event)"
                    @add="addContactDetailKey('vipCustomer', $event)"
                >
                    <template #icon>
                        <div class="material-icons">person</div>
                    </template>
                </ContactDetailItem>
                <ContactDetailItem
                    :contact="contact"
                    :label="$t('message.fullName')"
                    :value="getVal('fullname', 'N/A', false)"
                    :showEdit="true"
                    :showDelete="false"
                    :showCopy="true"
                    @edit="updateContactDetailKey('fullname', $event)"
                    @add="addContactDetailKey('fullname', $event)"
                >
                    <template #icon>
                        <div class="material-icons">person</div>
                    </template>
                </ContactDetailItem>
                <ContactDetailItem
                    :contact="contact"
                    :label="$t('message.email')"
                    :value="getVal('email')"
                    :showEdit="true"
                    :showDelete="false"
                    :showCopy="true"
                    field="email"
                    @edit="updateContactDetailKey('email', $event)"
                    @add="addContactDetailKey('email', $event)"
                >
                    <template #icon>
                        <div class="material-icons">alternate_email</div>
                    </template>
                </ContactDetailItem>
                <div class="contact-properties-box">
                    <div class="btnShowContactProperties" @click="showContactProperties = !showContactProperties">
                        <span v-if="showContactProperties">
                            {{ $t("message.hideOtherInfo") }}
                            <i class="material-icons">expand_less</i>
                        </span>
                        <span v-else>
                            {{ $t("message.showOtherInfo") }}
                            <i class="material-icons">expand_more</i>
                        </span>
                    </div>

                    <ContactProperties :contact="contact" :show-widget-title="false" v-if="showContactProperties" />
                </div>

                <ContactDetailItem
                    :contact="contact"
                    v-for="inputValue of getCustomLoginInfos()"
                    :label="inputValue.name"
                    :value="inputValue.value"
                    :key="inputValue.id"
                    :showDelete="false"
                    :showEdit="false"
                    :showAdd="false"
                    @updated="updateCustomLoginFormInfo(inputValue, $event)"
                >
                    <template #icon>
                        <div class="material-icons">alternate_email</div>
                    </template>
                    <template #value>
                        {{ inputValue.value }}
                    </template>
                </ContactDetailItem>

                <ContactDetailItem
                    :contact="contact"
                    :label="$t('whatsappChannel.channelName')"
                    :value="getPlatform()"
                    :showEdit="false"
                    :showDelete="false"
                    :showCopy="true"
                >
                    <template #icon>
                        <PlatformIcon :platform="contact.platform" :size="20" />
                    </template>
                </ContactDetailItem>

                <ContactDetailItem
                    :contact="contact"
                    :label="$t('message.preferredLanguage')"
                    :value="getPreferredLang()"
                    :showEdit="true"
                    :showDelete="false"
                    :showCopy="true"
                    field="preferredLang"
                    @edit="updatePreferredLang"
                >
                    <template #icon>
                        <FlagSvg />
                    </template>
                </ContactDetailItem>

                <ContactDetailItem
                    :contact="contact"
                    :label="$t('visitor.tags')"
                    :value="contact.tags"
                    :showEdit="true"
                    :showDelete="false"
                    :showCopy="true"
                    field="tags"
                    @edit="updateTags"
                >
                    <template #icon>
                        <TagSvg />
                    </template>
                </ContactDetailItem>
                <ContactDetailItem
                    v-if="contact.lastConversation.subject"
                    :contact="contact"
                    :label="$t('chatWindow.departmentToWhichItIsAffiliated')"
                    :value="subjectName(contact.lastConversation.subject)"
                    :showEdit="false"
                    :showDelete="false"
                    :showCopy="true"
                >
                    <template #icon>
                        <Department style="width: 20px; height: 20px" />
                    </template>
                </ContactDetailItem>
                <ContactDetailItem
                    v-if="contact.platform === 'web'"
                    :contact="contact"
                    :label="$t('message.visitingPage')"
                    :value="contact.visitingPage"
                    :showEdit="false"
                    :showDelete="false"
                    :showCopy="true"
                    :showAdd="false"
                >
                    <template #icon>
                        <BrowserSvg />
                    </template>
                </ContactDetailItem>
                <ContactDetailItem
                    v-if="getVal('languageCode', null)"
                    :contact="contact"
                    :label="$t('message.countryAndLanguage')"
                    :value="getCountryAndLanguage()"
                    :showEdit="false"
                    :showDelete="false"
                    :showCopy="true"
                >
                    <template #icon>
                        <FlagSvg />
                    </template>
                </ContactDetailItem>
                <ContactDetailItem
                    v-if="getOs() !== 'N/A'"
                    :contact="contact"
                    :label="$t('message.os_browser')"
                    :value="getOs()"
                    :showEdit="false"
                    :showDelete="false"
                    :showCopy="true"
                >
                    <template #icon>
                        <BrowserSvg />
                    </template>
                </ContactDetailItem>

                <ContactDetailItem
                    v-if="getVal('ipAddress', null)"
                    :contact="contact"
                    :label="$t('message.ipAddress')"
                    :value="getVal('ipAddress')"
                    :showEdit="false"
                    :showDelete="false"
                    :showCopy="true"
                >
                    <template #icon>
                        <BrowserSearchSvg />
                    </template>
                </ContactDetailItem>

                <ContactDetailItem
                    :contact="contact"
                    :label="$t('userInfoWidget.speechID')"
                    :value="getVal('lastConversation._id')"
                    :showEdit="false"
                    :showDelete="false"
                    :showCopy="true"
                >
                    <template #icon>
                        <UserCardSvg />
                    </template>
                </ContactDetailItem>

                <ContactDetailItem
                    :contact="contact"
                    :label="$t('message.visitorId')"
                    :value="getVal('_id')"
                    :showEdit="false"
                    :showDelete="false"
                    :showCopy="true"
                >
                    <template #icon>
                        <FingerSvg />
                    </template>
                </ContactDetailItem>
            </div>
        </div>
        <TagDialog
            v-if="showTagDialog"
            :value="getContactTagIds()"
            @input="contactTagUpdated"
            @close="showTagDialog = false"
        />
    </div>
</template>
<script>
import ContactSvg from "./svg/ContactSvg.vue";
import FlagSvg from "./svg/FlagSvg.vue";
import AgentsInfoSvg from "./svg/AgentsInfoSvg.vue";
import BrowserSvg from "./svg/BrowserSvg.vue";
import BrowserSearchSvg from "./svg/BrowserSearchSvg.vue";
import UserCardSvg from "./svg/UserCardSvg.vue";
import FingerSvg from "./svg/FingerSvg.vue";
import TagSvg from "./svg/TagSvg.vue";
import { mapActions, mapState } from "vuex";
import ContactDetailItem from "./ContactDetailItem.vue";
import CountryFlag from "vue-country-flag";
import countryCodes from "../../../utils/countryCodes";
import ContactAvatar from "./ContactAvatar.vue";
import _ from "lodash";
import SupsisButton from "../../../views/Pages/Settings/components/SupsisButton.vue";
import TagDialog from "../../TagDialog.vue";
import { sendSocketMessage } from "../../../utils/socketStream";
import UpdateContactLang from "./UpdateContactLang.vue";
import languages from "../../../language/languages.json";
import webIcon from "../../../views/Pages/Visitors/components/svg/WebIcon.vue";
import InstagramIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/InstagramIcon.vue";
import WhatsappIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import MetaIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/MetaIcon.vue";
import TelegramIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/TelegramIcon.vue";
import MessengerIcon from "../../../views/Pages/Chatbot/pages/integrations/svg/MessengerIcon.vue";
import BrowserSvg2 from "./svg/Browser2Svg.vue";
import WhatsappSvg from "./svg/WhatsappSvg.vue";
import PlatformIcon from "./ChatMessageArea/components/PlatformIcon.vue";
import WhatsappChatStarter from "../../../views/Pages/Integrations/meta-leads/WhatsappChatStarter.vue";
import Modal2 from "../../common/Modal2.vue";
import ContactProperties from "./ContactProperties.vue";
import Department from "./svg/Department.vue";
import { isMaskContactInfo, maskContactInfo } from "../../../utils/utils";

export default {
    name: "ContactDetail",
    components: {
        ContactProperties,
        PlatformIcon,
        WhatsappSvg,
        BrowserSvg2,
        MessengerIcon,
        TelegramIcon,
        MetaIcon,
        WhatsappIcon,
        InstagramIcon,
        webIcon,
        UpdateContactLang,
        TagDialog,
        SupsisButton,
        ContactAvatar,
        ContactDetailItem,
        TagSvg,
        FingerSvg,
        UserCardSvg,
        BrowserSearchSvg,
        BrowserSvg,
        AgentsInfoSvg,
        FlagSvg,
        ContactSvg,
        CountryFlag,
        WhatsappChatStarter,
        Modal2,
        Department,
    },
    props: {
        contact: {
            type: Object,
            default: () => ({}),
        },
        showProfileTop: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        showTagDialog: false,
        showWhatsappChatStarterModal: false,
        showContactProperties: localStorage.getItem("showContactProperties") === "true" || false,
    }),
    computed: {
        ...mapState({
            authUser: (state) => state.auth.user,
            users: (state) => state.user.users.data,
            site: (state) => state.site.site,
            liveVisitors: (state) => state.visitor.liveVisitors,
            inputs: (state) =>
                state.customLoginForm.inputs.reduce((acc, cur) => {
                    acc[cur._id] = cur;
                    return acc;
                }, {}),
            subjects: (state) => state.subject.subjects.data,
            channels: (state) => state.channel.channels,
            zohoChannelExists: (state) => !!state.channel.channels.some((channel) => channel.type === "zoho"),
            maskSensitiveInfo: (state) => state.setting.settings.maskSensitiveInfo,
            isRoot: (state) => _.get(state, "auth.user.role.isRoot", false),
        }),
    },
    mounted() {
        this.getTags("contact");
    },
    methods: {
        isMaskContactInfo,
        isShouldMask(val) {
            return (
                !this.isRoot &&
                this.maskSensitiveInfo &&
                (val === this.contact.email || val === this.contact.whatsappNumber || val === this.contact.phone)
            );
        },
        maskContactInfo(key, val, length = 4) {
            return isMaskContactInfo(key)
                ? maskContactInfo(val, length)
                : this.isShouldMask(val)
                ? maskContactInfo(val, length)
                : val;
        },
        ...mapActions({
            addNewWindow: "app/addNewWindow",
            updateVisitorTags: "visitor/updateTagVisitor",
            createNote: "visitor/createVisitorNote",
            updateMultipleKeyContact: "chat/updateMultipleKeyContact",
            updateVisitorAttr: "visitor/updateVisitorAttr",
            updateCustomLoginInfo: "chat/updateCustomLoginInfo",
            getTags: "tag/getTags",
        }),
        updateCustomLoginFormInfo(input, value) {
            const customLoginInfos = this.contact.lastConversation.customLoginInfos.map((item) => {
                if (item.input === input.id) {
                    item.value = value;
                }
                return item;
            });
            this.updateCustomLoginInfo({
                conversationId: this.contact.lastConversation._id,
                customLoginInfos,
            }).then(() => {
                this.updateMultipleKeyContact({
                    contactId: this.contact._id,
                    set: {
                        lastConversation: {
                            ...this.contact.lastConversation,
                            customLoginInfos,
                        },
                    },
                });
            });
        },
        updateContactDetailKey(field, value) {
            console.log("updateContactDetailKey tetiklendi", { field, value });

            const updateContact = () => {
                this.updateVisitorAttr({
                    visitorId: this.contact._id,
                    payload: {
                        [field]: value,
                    },
                }).then(() => {
                    this.updateMultipleKeyContact({
                        contactId: this.contact._id,
                        set: {
                            [field]: value,
                        },
                    });

                    const payload = {
                        siteId: this.site._id,
                        visitorId: this.contact._id,
                        updatingFields: {
                            [field]: value,
                        },
                        oldOwner: this.contact.owner,
                        lastConversationId: this.$_.get(this.contact, "lastConversation._id"),
                        autUser: this.authUser._id,
                    };

                    if (field === "owner") {
                        const isActiveConversation = this.$_.get(this.contact, "lastConversation.status") === "active";
                        if (isActiveConversation) payload.conversationId = this.contact.lastConversation._id;
                    }

                    if (field === "owner" && this.zohoChannelExists) {
                        this.$confirm({
                            title: "Zoho Senkronizasyonu",
                            content: "Kişi değişiklik işlemlerini Zoho'da da yapmak istiyor musunuz?",
                            onOk: () => {
                                payload.publishToZoho = true;
                                sendSocketMessage("visitor profile-updated", payload);
                            },
                            onCancel: () => {
                                sendSocketMessage("visitor profile-updated", payload);
                            },
                        });
                    } else {
                        sendSocketMessage("visitor profile-updated", payload);
                    }
                });
            };

            updateContact();
        },
        getPlatform() {
            const platform = this.contact.platform;
            if (!this.contact.channel) return platform;
            const channelsMap = this.channels.reduce((acc, cur) => {
                acc[cur._id] = cur;
                return acc;
            }, {});
            return channelsMap[this.contact.channel]?.name || platform;
        },
        getPlatformName() {
            const platformMap = {
                whatsapp: "WhatsApp",
                telegram: "Telegram",
                messenger: "Messenger",
                web: "Web",
                email: "Email",
                "meta-leads": "Meta",
                instagram: "Instagram",
            };
            return platformMap[this.contact.platform] || this.contact.platform;
        },
        getContactTagIds() {
            return this.contact.tags?.map((tag) => (typeof tag === "string" ? tag : tag._id)) || [];
        },
        contactTagUpdated: _.debounce(function (v) {
            this.updateMultipleKeyContact({
                contactId: this.contact._id,
                set: {
                    tags: v,
                },
            });
            this.updateVisitorTags({
                visitorId: this.contact._id,
                tagIds: v,
            });
        }, 300),
        saveContactLanguage(preferredLang) {
            sendSocketMessage("visitor lang-change", {
                visitorId: this.contact._id,
                siteId: this.site._id,
                preferredLang: preferredLang,
                conversationId: this.contact.lastConversation._id,
            });
            sendSocketMessage("visitor profile-updated", {
                visitorId: this.contact._id,
                siteId: this.site._id,
            });
            this.updateMultipleKeyContact({
                contactId: this.contact._id,
                set: {
                    preferredLang,
                },
            });
        },
        getTagsName() {
            return (
                (this.contact.tags || [])
                    .map((tag) => tag?.name)
                    .filter((s) => s)
                    .join(",") || "-"
            );
        },
        getVal(path, defaultVal = "N/A", mask = true) {
            return mask
                ? this.maskContactInfo(path, _.get(this.contact, path, defaultVal))
                : _.get(this.contact, path, defaultVal);
        },
        getAgents(isString = false) {
            const usersHash = this.users.reduce((acc, user) => {
                acc[user._id] = user;
                return acc;
            }, {});
            const agentIds = this.getVal("users", []);
            const arr = agentIds.map((agentId) => usersHash[agentId]);
            return isString ? arr.map((val) => val.name || "Bilinmiyor").join(",") : arr;
        },
        getCountryName(country = "") {
            const q = country.toLowerCase().trim();
            const maybeCountry = countryCodes.find(
                (x) => x.name.toLowerCase().trim() === q || x.code.toLowerCase().trim() === q
            );
            return maybeCountry ? maybeCountry.name : country;
        },
        getOs() {
            return this.contact.platform === "web"
                ? this.contact.os || this.contact.browser
                    ? this.contact.os + "/" + this.contact.browser
                    : "N/A"
                : this.getPlatformName();
        },
        IsVisitorOnline() {
            if (this.contact.channel) return true;
            const isWhatsappVisitor = !!_.get(this.contact, "whatsappNumber");
            const isInstagramVisitor = !!_.get(this.contact, "instagramUserId");
            const isMessengerVisitor = !!_.get(this.contact, "messengerUserId");
            const isTelegramVisitor = !!_.get(this.contact, "telegramUserId");
            if (isWhatsappVisitor || isInstagramVisitor || isTelegramVisitor || isMessengerVisitor) return true;
            else return this.liveVisitors.includes(this.contact._id);
        },
        viewContactProfile() {
            this.addNewWindow({
                type: "show-visitor",
                title: this.contact.fullname,
                payload: {
                    visitorId: this.contact._id,
                },
            });
        },
        getSubjectName(id) {
            let maybeSubject = this.subjects.find((x) => x._id == id);
            return maybeSubject ? maybeSubject.languageContent[this.$i18n.locale].name : undefined;
        },
        getCustomLoginInfos() {
            let inputValues = this.contact.lastConversation.customLoginInfos || [];
            const hashMapContactProperty = (this.contact?.contactProperties || []).reduce((a, b) => {
                a[b.property._id] = true;
                return a;
            }, {});

            inputValues = inputValues
                .filter((x) => this.inputs[x.input])
                .filter((x) => !["email", "fullname", "subject", "json"].includes(this.inputs[x.input].type))
                .filter((x) => !hashMapContactProperty[this.inputs[x.input]?.contactProperty])
                .map((v) => {
                    const current = this.inputs[v.input];
                    const langs = Object.keys(_.get(current, "localizedLabel", {}));
                    const lang = langs.includes(this.$i18n.locale) ? this.$i18n.locale : langs[0];
                    const name = _.get(current, `localizedLabel.${lang}.text`, "");
                    const isSubject = _.get(current, "type") === "subject";
                    return {
                        value: isSubject ? this.getSubjectName(v.value) : v.value,
                        name,
                        id: _.get(current, "_id"),
                    };
                });
            return inputValues;
        },
        getCountryAndLanguage() {
            return `${this.getCountryName(this.getVal("languageCode"))} / ${this.getVal("languageCode")}`;
        },
        getPreferredLang() {
            return languages.find((lang) => lang.code === this.contact.preferredLang)?.originalName;
        },
        updatePreferredLang(newLang) {
            this.updateContactDetailKey("preferredLang", newLang);
        },
        updateTags(newTags) {
            this.updateMultipleKeyContact({
                contactId: this.contact._id,
                set: {
                    tags: newTags,
                },
            });
            this.updateVisitorTags({
                visitorId: this.contact._id,
                tagIds: newTags,
            });
        },
        startWhatsappChat() {
            this.$emit("start-whatsapp-chat", this.contact.whatsappNumber);
        },
        addContactDetailKey(field, value) {
            this.updateVisitorAttr({
                visitorId: this.contact._id,
                payload: {
                    [field]: value,
                },
            }).then(() => {
                this.updateMultipleKeyContact({
                    contactId: this.contact._id,
                    set: {
                        [field]: value,
                    },
                });
                sendSocketMessage("visitor profile-updated", {
                    siteId: this.site._id,
                    visitorId: this.contact._id,
                });
            });
        },
        subjectName(subjectId) {
            const subject = this.subjects.find((x) => x._id == subjectId);
            return subject ? subject.languageContent[this.$i18n.locale].name : "";
        },
    },
    watch: {
        showContactProperties: function (val) {
            localStorage.setItem("showContactProperties", val);
        },
    },
};
</script>
<style lang="scss" scoped>
.contact-details {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .user-info-profile {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        border: 1px solid #f1f4f7;
        border-radius: 8px;
        background-color: #fff;
        cursor: pointer;

        .profile-header {
            display: flex;
            align-items: center;
            gap: 10px;
            width: 100%;

            .contact-profile-info {
                display: flex;
                flex-direction: column;
                gap: 5px;
                align-items: flex-start;

                .contact-profile-fullname {
                    font-weight: bold;
                    font-size: 16px;
                    display: flex;
                    align-items: center;
                    gap: 4px;

                    .material-icons.vip {
                        font-size: 18px;
                        background: -webkit-linear-gradient(#d6ea2d, #f960cb, #9037d4);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }
                }

                .platform-info {
                    display: flex;
                    flex-direction: column;
                    gap: 2px;
                    font-size: 12px;
                    color: #8c8c8c;
                    font-weight: 500;

                    .platform-name {
                        &:hover {
                            cursor: pointer;
                            text-decoration: underline;
                        }
                    }

                    .platform-icon-wrapper {
                        display: flex;
                        gap: 5px;

                        .option-icon {
                            width: 16px;
                            height: 16px;
                        }
                    }

                    .whatsapp-number {
                        cursor: pointer;
                        color: #007bff;
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    .user-info-details-wrapper {
        display: flex;
        flex-direction: column;
        gap: 15px;
        padding: 10px 20px;

        .user-info-details-title {
            font-weight: bold;
            font-size: 16px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .user-info-details-content {
            display: flex;
            flex-direction: column;
            gap: 15px;
        }
    }

    .contact-properties-box {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .widget-content {
            padding: 0;
        }

        .btnShowContactProperties {
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            color: #007bff;
            font-size: 14px;
            font-weight: 500;

            .material-icons {
                font-size: 16px;
            }
        }
    }
}
</style>
<style lang="scss">
.contact-properties-box {
    .widget-content {
        padding: 0 !important;

        .drag-row {
            padding: 0 !important;
        }
    }
}
</style>
